import { DialogRef, DIALOG_DATA } from '@angular/cdk/dialog';
import { Component, inject } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ToastrFactoryService } from 'src/app/services/toastr-factory.service';
import { QrCodeHandlerComponentComponent } from '../../qr-code-handler-component/qr-code-handler-component.component';
import { ModalBaseComponent } from 'src/app/shared/components/modal-base/modal-base.component';

@Component({
  selector: 'app-share-modal',
  imports: [TranslateModule, QrCodeHandlerComponentComponent, ModalBaseComponent],
  templateUrl: './share-modal.component.html',
})
export class ShareModalComponent {
  protected toastrFactory = inject(ToastrFactoryService);
  protected translate = inject(TranslateService);

  protected dialogRef = inject(DialogRef);
  protected data = inject(DIALOG_DATA);

  copyProfileUrl() {
    const profileUrl = this.getProfileUrl();
    navigator.clipboard.writeText(profileUrl);
    this.toastrFactory.success(
      this.translate.instant('public-profile.theLinkToYourNickyPublicProfileHasBeenCopied'),
      '',
      {
        timeOut: 3000,
      },
    );
  }

  getProfileUrl() {
    return `${window.location.origin}/s/${this.data.profileInfo.shortId}`;
  }
}
